import {useCallback, useMemo} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'

export const useQueryParams = () => {
    const location = useLocation()
    const navigate = useNavigate()

    const params = useMemo(() => new URLSearchParams(location.search), [location.search])

    const getParam = useCallback((key) => params.get(key) || '', [params])

    const hasParams = useMemo(() => params.toString().length > 0, [params.toString()])

    const clearParams = useCallback(
        (key = '') => {
            const newParams = new URLSearchParams(location.search)
            if (key) {
                newParams.delete(key)
            } else {
                [...newParams.entries()].map(([key]) => {
                    newParams.delete(key)
                })
            }
            navigate({search: newParams.toString()}, {replace: true})
        },
        [location.search, navigate]
    )

    return {params, getParam, hasParams, clearParams}
}
